import { Modal } from "antd";
import "../../components/design/CreateFolderModal.scss";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import { DsaCreateFolderContent } from "./DsaCreateFolderContent";

export interface DsaCreateFolderModalProps {
  uploadIds: string[];
  isVisible: boolean;
  onClose: (uploadIds: string[], folderToMove?: DsaUploadFolderDto | null, folder?: DsaUploadFolderDto) => void;
  folderToMove: DsaUploadFolderDto | null;
  folderNameExists: (folder: DsaUploadFolderDto | null, name: string) => boolean | undefined;
  activeFolder: DsaUploadFolderDto | null;
}

export function DsaCreateFolderModal({
  uploadIds,
  isVisible,
  onClose,
  folderToMove,
  folderNameExists,
  activeFolder
}: DsaCreateFolderModalProps) {
  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose([])}
    >
      <DsaCreateFolderContent
        uploadIds={uploadIds}
        onClose={onClose}
        folderToMove={folderToMove}
        parentFolder={activeFolder}
        folderNameExists={folderNameExists}
      />
    </Modal>
  );
}
